module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "Demo Reivew V2",
      "width": "750"
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('Row', [_c('div', {
    staticClass: "evaluate"
  }, [_c('h2', [_vm._v("Part one: Learning Status ")]), _vm._v(" "), _c('h3', [_vm._v("Child’s Engagement  : "), _c('span', {
    staticClass: "choose"
  }, [_vm._v("(Please choose a type)")]), _vm._v(" "), _c('span', [_c('Button', {
    attrs: {
      "type": _vm.partData.part1.type === 'typeA' ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('part1', 'typeA')
      }
    }
  }, [_vm._v("typeA")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": _vm.partData.part1.type === 'typeB' ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('part1', 'typeB')
      }
    }
  }, [_vm._v("typeB")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": _vm.partData.part1.type === 'typeC' ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('part1', 'typeC')
      }
    }
  }, [_vm._v("typeC")])], 1)]), _vm._v(" "), (_vm.partData.part1.type === 'typeA') ? _c('h4', [_vm._v("\n        Hi " + _vm._s(_vm.nickname) + ", you were highly engaged in class, showing exceptional participation! You asked questions proactively and made great efforts to use new sentence structures in your responses. Excellent work in class today!\n      ")]) : _vm._e(), _vm._v(" "), (_vm.partData.part1.type === 'typeB') ? _c('h4', [_vm._v("\n        Hi " + _vm._s(_vm.nickname) + ", you were overall active in class participation, though you occasionally needed gentle prompts (e.g., hand gestures) to share more details or join in. Keep up the good work—your involvement was fantastic!\n      ")]) : _vm._e(), _vm._v(" "), (_vm.partData.part1.type === 'typeC') ? _c('h4', [_vm._v("\n        Hi " + _vm._s(_vm.nickname) + ", you seemed a bit shy in class, responding to questions in a soft voice and rarely initiating conversations. It was wonderful to see you try when guided patiently, though! Looking forward to seeing more of your participation in future classes—you’ve got this!\n      ")]) : _vm._e()])]), _vm._v(" "), _c('Row', [_c('div', {
    staticClass: "evaluate"
  }, [_c('h2', [_vm._v("Part two: Learning Ability  :")]), _vm._v(" "), _c('h3', [_vm._v("1. Listening Ability Evaluation  :"), _c('span', {
    staticClass: "choose"
  }, [_vm._v("(Please choose a type)")]), _vm._v(" "), _c('span', [_c('Button', {
    attrs: {
      "type": _vm.partData.part2.type === 'typeA' ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('part2', 'typeA')
      }
    }
  }, [_vm._v("typeA")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": _vm.partData.part2.type === 'typeB' ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('part2', 'typeB')
      }
    }
  }, [_vm._v("typeB")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": _vm.partData.part2.type === 'typeC' ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('part2', 'typeC')
      }
    }
  }, [_vm._v("typeC")])], 1)]), _vm._v(" "), (_vm.partData.part2.type === 'typeA') ? _c('h4', [_c('span', {
    staticClass: "title"
  }, [_vm._v("you grasped information accurately and followed instructions flawlessly")]), _vm._v(". You also demonstrated clear understanding of key details like greetings, class extensions, and dialogues/passages in the materials.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.partData.part2.type === 'typeB') ? _c('h4', [_c('span', {
    staticClass: "title"
  }, [_vm._v("you comprehended information adequately and followed most instructions correctly")]), _vm._v(". You understood surface-level details such as basic greetings, simple class extensions, and straightforward dialogues from the materials.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.partData.part2.type === 'typeC') ? _c('h4', [_c('span', {
    staticClass: "title"
  }, [_vm._v("you grasped information vaguely and followed some of the instructions correctly")]), _vm._v(". Besides, you required repeated instructions and demonstrations to process even foundational elements like basic greetings, simple class cues, or short phrases from the materials.\n      ")]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v("2. Oral Ability Evaluation  :"), _c('span', {
    staticClass: "choose"
  }, [_vm._v("(Please choose a type)")]), _vm._v(" "), _c('span', [_c('Button', {
    attrs: {
      "type": _vm.partData.part3.type === 'typeA' ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('part3', 'typeA')
      }
    }
  }, [_vm._v("typeA")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": _vm.partData.part3.type === 'typeB' ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('part3', 'typeB')
      }
    }
  }, [_vm._v("typeB")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": _vm.partData.part3.type === 'typeC' ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('part3', 'typeC')
      }
    }
  }, [_vm._v("typeC")])], 1)]), _vm._v(" "), (_vm.partData.part3.type === 'typeA') ? _c('h4', [_vm._v("\n        You demonstrated excellent speaking skills with clear pronunciation—only minor slips, such as "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partData.part3.words),
      expression: "partData.part3.words"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.partData.part3.words)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.partData.part3, "words", $event.target.value)
      }
    }
  }), _vm._v(", and fluent verbal output. You voluntarily spoke in full sentences, showing strong command of the content.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.partData.part3.type === 'typeB') ? _c('h4', [_vm._v("\n        Your speaking skills were moderate, with minor pronunciation issues (e.g., "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partData.part3.words),
      expression: "partData.part3.words"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.partData.part3.words)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.partData.part3, "words", $event.target.value)
      }
    }
  }), _vm._v(") and average fluency. You could expand into full sentences when prompted, showing basic ability to elaborate.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.partData.part3.type === 'typeC') ? _c('h4', [_vm._v("\n        Your speaking skills were weak, with frequent pronunciation errors (e.g., "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partData.part3.words),
      expression: "partData.part3.words"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.partData.part3.words)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.partData.part3, "words", $event.target.value)
      }
    }
  }), _vm._v("). You often got stuck mid-sentence, struggling with words or phrases, and required word-by-word guidance to complete expressions.\n      ")]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v("3. Reading Ability Evaluation  :"), _c('span', {
    staticClass: "choose"
  }, [_vm._v("(Please choose a type)")]), _vm._v(" "), _c('span', [_c('Button', {
    attrs: {
      "type": _vm.partData.part4.type === 'typeA' ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('part4', 'typeA')
      }
    }
  }, [_vm._v("typeA")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": _vm.partData.part4.type === 'typeB' ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('part4', 'typeB')
      }
    }
  }, [_vm._v("typeB")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": _vm.partData.part4.type === 'typeC' ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('part4', 'typeC')
      }
    }
  }, [_vm._v("typeC")])], 1)]), _vm._v(" "), (_vm.partData.part4.type === 'typeA') ? _c('h4', [_vm._v("\n        You read fluently and expressively, with a strong grasp of underlying logic. New and high-frequency words were pronounced correctly, with natural pauses at phrase chunks.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.partData.part4.type === 'typeB') ? _c('h4', [_vm._v("\n        Your reading was somewhat halting, but you grasped surface meanings well. Most words were correct, with slight pauses on longer ones.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.partData.part4.type === 'typeC') ? _c('h4', [_vm._v("\n        Your reading was halting, with recognition limited to basics. Mispronunciations and struggles with new words were common.\n      ")]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v("4. Grammar & Vocabulary Evaluation  :"), _c('span', {
    staticClass: "choose"
  }, [_vm._v("(Please choose a type)")]), _vm._v(" "), _c('span', [_c('Button', {
    attrs: {
      "type": _vm.partData.part5.type === 'typeA' ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('part5', 'typeA')
      }
    }
  }, [_vm._v("typeA")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": _vm.partData.part5.type === 'typeB' ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('part5', 'typeB')
      }
    }
  }, [_vm._v("typeB")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": _vm.partData.part5.type === 'typeC' ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('part5', 'typeC')
      }
    }
  }, [_vm._v("typeC")])], 1)]), _vm._v(" "), (_vm.partData.part5.type === 'typeA') ? _c('h4', [_vm._v("\n        Your grammar and vocabulary were advanced. You made only occasional minor grammar errors "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partData.part5.words),
      expression: "partData.part5.words"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.partData.part5.words)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.partData.part5, "words", $event.target.value)
      }
    }
  }), _vm._v("(e.g., tense misuse, article/plural mistakes, verb collocation issues, sentence fragments, or confusing adjectives/adverbs) and showed a strong ability to self-correct. You voluntarily used advanced vocabulary and confidently experimented with creating new sentences.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.partData.part5.type === 'typeB') ? _c('h4', [_vm._v("\n        Your grammar and vocabulary were at a basic level. You made a few grammar errors "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partData.part5.words),
      expression: "partData.part5.words"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.partData.part5.words)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.partData.part5, "words", $event.target.value)
      }
    }
  }), _vm._v("(e.g., tense misuse, article/plural mistakes, verb collocation issues, sentence fragments, or confusing adjectives/adverbs) but caught on quickly when reminded. You were skilled at using familiar words and occasionally tried new ones, though you may misuse them at times.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.partData.part5.type === 'typeC') ? _c('h4', [_vm._v("\n        Your grammar and vocabulary were developing and would benefit from focusing on basics first. You often made pronunciation errors or got stuck on new words, and you currently recognized mostly basic vocabulary. It would help to start with foundational grammar "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partData.part5.words),
      expression: "partData.part5.words"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.partData.part5.words)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.partData.part5, "words", $event.target.value)
      }
    }
  }), _vm._v("(e.g., tense usage, article/plural rules, verb collocations, complete sentences, or adjective/adverb differences) and practice using new words in simple sentences step by step.\n      ")]) : _vm._e()])]), _vm._v(" "), _c('Row', [_c('div', {
    staticClass: "evaluate"
  }, [_c('h2', [_vm._v("Part three: Summary  :")]), _vm._v(" "), _c('h3', [_vm._v("Summary of overall performance.  :"), _c('span', {
    staticClass: "choose"
  }, [_vm._v("(Please choose a type)")]), _vm._v(" "), _c('span', [_c('Button', {
    attrs: {
      "type": _vm.partData.part6.type === 'typeA' ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('part6', 'typeA')
      }
    }
  }, [_vm._v("typeA")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": _vm.partData.part6.type === 'typeB' ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('part6', 'typeB')
      }
    }
  }, [_vm._v("typeB")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": _vm.partData.part6.type === 'typeC' ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('part6', 'typeC')
      }
    }
  }, [_vm._v("typeC")])], 1)]), _vm._v(" "), (_vm.partData.part6.type === 'typeA') ? _c('h4', [_vm._v("\n        Overall, I was thoroughly impressed with your engagement in today’s class! Your proactive questions and eagerness to experiment with new sentence structures made your participation truly standout. It was a joy to have you in class, and I’m already looking forward to our next session—keep up this fantastic energy!\n      ")]) : _vm._e(), _vm._v(" "), (_vm.partData.part6.type === 'typeB') ? _c('h4', [_vm._v("\n        Overall, your participation in class was great to see! While you occasionally needed a little nudge to share more, you jumped in willingly and kept the momentum going. Keep building on that—your effort shines through, and I can’t wait to see you grow even more in our next class!​\n      ")]) : _vm._e(), _vm._v(" "), (_vm.partData.part6.type === 'typeC') ? _c('h4', [_vm._v("\n        Overall, I appreciated seeing you step into class today—even if you felt a bit shy. You answered questions thoughtfully, and with a little patience, you opened up more than you might realize. Let’s keep that going! I’m looking forward to our next class, where I hope to hear your voice a little louder and see you start a conversation or two—you’ve got so much to share!\n      ")]) : _vm._e()])]), _vm._v(" "), _c('Row', [_c('div', {
    staticClass: "evaluate"
  }, [_c('h2', [_vm._v("Part four: Learning Suggestions  :")]), _vm._v(" "), _c('h4', [_vm._v("\n        The demo level is\n        "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partData.part7.words),
      expression: "partData.part7.words"
    }],
    staticClass: "redBorder",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.partData.part7, "words", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.levelNames), function(item) {
    return _c('option', {
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 0), _vm._v(" for the student because "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partData.part8.words),
      expression: "partData.part8.words"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.partData.part8.words)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.partData.part8, "words", $event.target.value)
      }
    }
  }), _vm._v("(fill the reason if level is a bit difficult or a bit easy).\n      ")]), _vm._v(" "), _c('h2'), _vm._v(" "), _c('h3', [_c('span', {
    staticClass: "choose"
  }, [_vm._v("(Please choose one or both suggestions for student.)")])]), _vm._v(" "), _c('h4', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partData.part9.words),
      expression: "partData.part9.words"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.partData.part9.words) ? _vm._i(_vm.partData.part9.words, null) > -1 : (_vm.partData.part9.words)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.partData.part9.words,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.partData.part9, "words", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.partData.part9, "words", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.partData.part9, "words", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("*suggestion 1*For listening and speaking practice,")]), _vm._v(" it is recommended to listen to English songs, podcasts, English stories, etc., and engage in shadowing, imitation, and even retelling exercises. For difficult pronunciations and vocabulary, learn from teachers.\n      ")]), _vm._v(" "), _c('h4', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partData.part10.words),
      expression: "partData.part10.words"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.partData.part10.words) ? _vm._i(_vm.partData.part10.words, null) > -1 : (_vm.partData.part10.words)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.partData.part10.words,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.partData.part10, "words", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.partData.part10, "words", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.partData.part10, "words", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("*suggestion 2*In reading, grammar, and vocabulary sections,")]), _vm._v("\n        try to read interesting English materials such as picture books and chapter books to accumulate vocabulary and sentence patterns through reading. For grammar, do targeted exercises on problematic grammar points to consolidate learning, and consult teachers for clarification on doubts.\n      ")]), _vm._v(" "), _c('h4', [_vm._v("\n        Also,  I suggest starting your English journey from "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.evaluation),
      expression: "evaluation"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.evaluation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.evaluation = $event.target.value
      }
    }
  }), _vm._v(" (a particular level that we have) and taking classes twice or three times a week to ensure a great learning outcome.\n      ")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (!_vm.readonly) ? _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("Submit")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d346771","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/StudentWriteReviewDemoV2Modal.vue
// module id = 1668
// module chunks = 8